<ng-template #communicationModalForm role="document" let-modal>

  <app-page-comp-header
  button0Text="Bulk Reserve"
  button1Text="Bulk Order"
  [initialCompanyId]="this.enteredByCompanyId"
  [showCompanyDropdown]="!readonly"
  [showReplyIcon]="readonly && showReplyIcon && !isLegacySms"
  [title]="formTitle"
  (cancelButtonOnClick)="communicationFormCancel()"
  (companyDropDownChange)="companySelectDropDownChange($event)"
  (replyButtonOnClick)="replyMessageClick()"
></app-page-comp-header>

  <form (ngSubmit)="communicationFormSubmit()" [formGroup]="communicationForm" class="tablelist-form" autocomplete="off">
    <div class="modal-body">

      @if (readonly) {
        <div class="row">
          <div class="col-md-6">
            <div class="mb-3">
              <label class="form-label text-muted">Type</label>
              <div class="fs-15 fw-medium">{{ communicationTypeDescription }}</div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-3">
              <label class="form-label text-muted">Method</label>
              <div class="fs-15 fw-medium">{{ communication?.method }}</div>
            </div>
          </div>
        </div>

        <div class="row">
          @if (communication?.enteredByName) {
            <div class="col-md-6">
              <div class="mb-3">
                <label class="form-label text-muted">From</label>
                <div class="fs-15 fw-medium">{{ communication?.enteredByName }}</div>
              </div>
            </div>
          }
          @if (communication?.enteredByCompanyName) {
            <div class="col-md-6">
              <div class="mb-3">
                <label class="form-label text-muted">From Company</label>
                <div class="fs-15 fw-medium">{{ communication?.enteredByCompanyName }}</div>
              </div>
            </div>
          }
        </div>

        @if (toEmails.length>0 || toCompanies.length>0) {
          <div class="row">
            @if (toEmails.length>0) {
              <div class="col-md-6">
                <div class="mb-3">
                  <label class="form-label text-muted">To</label>
                  <div class="fs-15 fw-medium">
                    @for (email of toEmails; track $index) {
                      <div>{{ email }}</div>
                    }
                  </div>
                </div>
              </div>
            }
            @if (toCompanies.length>0) {
              <div class="col-md-6">
                <div class="mb-3">
                  <label class="form-label text-muted">To Company</label>
                  <div class="fs-15 fw-medium">
                    @for (company of toCompanies; track $index) {
                      <div>{{ company }}</div>
                    }
                  </div>
                </div>
              </div>
            }
          </div>
        }

        <div class="row">
          <div class="col-md-6">
            <div class="mb-3">
              <label class="form-label text-muted">Date</label>
              <div class="fs-15 fw-medium">{{ (communication?.enteredDate ?? communication?.startDate) | date:'dd/MM/yyyy HH:mm:ss':'UTC' }}</div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <label class="form-label text-muted">Subject</label>
              <div class="fs-15 fw-medium">{{ communication?.subject }}</div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <label class="form-label text-muted">Message</label>
              <div class="border rounded p-3 bg-light" style="white-space: pre-wrap;">{{ communication?.message }}</div>
            </div>
          </div>
        </div>

        @if (!isLegacySms) {
          <div class="row">
            <div class="col-12">
              <div class="form-check form-switch form-switch-md mb-3">
                <label class="form-check-label" for="read-field">Message Read</label>
                <input class="form-check-input" type="checkbox" role="switch" id="read-field" formControlName="read" (click)="readOrUnreadClick()">
              </div>
            </div>
          </div>
        }

        @if (!isLegacySms && deliveryResults.length>0) {
          <div class="row">
            <div class="col-12">
              <div class="mb-0">
                <label class="form-label text-muted">Delivery Results</label>
                <div class="table-responsive">
                  <table class="table table-sm table-bordered align-middle mb-0">
                    <thead class="table-light">
                      <tr>
                        <th>User</th>
                        <th>Channel</th>
                        <th>Provider</th>
                        <th>Status</th>
                        <th>Reason</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (result of deliveryResults; track $index) {
                        <tr>
                          <td>{{ result.recipientName }}</td>
                          <td>{{ result.channel }}</td>
                          <td>{{ result.provider }}</td>
                          <td class="fw-medium" [ngClass]="deliveryStatusClass(result.status)">{{ result.status }}</td>
                          <td class="text-danger small">{{ result.failureReason }}</td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        }
      } @else {

      @if (canMessageBaseWide && !readonly && !gotInitialCompanyOrUser) {
        <div class="row">
          <div class="col-12">
            <div class="mt-0 mb-0">
              <label class="form-label text-right"></label>
              <div class="alert border-0 alert-warning text-center" role="alert" style="margin-top: -30px;">
                <strong>Warning - Messages without a Company or User are base wide</strong>
              </div>
            </div>
          </div>
        </div>
      }

      @if (!readonly) {
        <div class="row">
          <div class="col-6">
            <!-- <div class="mb-3">
              <label for="companyId-field" class="form-label text-right">Company</label>
              <div class="input-group">
                <select
                  class="form-select"
                  name="companyId-field"
                  id="companyId-field"
                  formControlName="companyId"
                  [ngClass]="{ 'is-invalid': formSubmitted && formOfCommunication['companyId'].errors }"
                  (change)="companySelectDropDownChange($event)"
                >
                  <option selected></option>
                  @for (object of getDropdownDataObjectArray("companyId"); track object.id) {
                    <option [ngValue]="object.id">{{object.description}}</option>    
                  }
                </select>
                <div class="invalid-feedback">A value is required</div>
              </div>
            </div> -->
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label for="userId-field" class="form-label text-right">User</label>
              <div class="input-group">
                <select
                  class="form-select"
                  name="userId-field"
                  id="userId-field"
                  formControlName="userId"
                  [ngClass]="{ 'is-invalid': formSubmitted && formOfCommunication['userId'].errors }"
                >
                  <option selected></option>
                  @for (object of getDropdownDataObjectArray("userId"); track object.id) {
                    <option [ngValue]="object.id">{{object.description}}</option>    
                  }
                </select>
                <div class="invalid-feedback">A value is required</div>
              </div>
            </div>
          </div>
        </div>
      }

      <div class="row">
        <div class="col-12">
          <div class="mb-3">
            <label for="communicationTypeId-field" class="form-label text-right">Communication Type</label>
            <div class="input-group">
              <select
                class="form-select"
                name="communicationTypeId-field"
                id="communicationTypeId-field"
                formControlName="communicationTypeId"
                [ngClass]="{ 'is-invalid': formSubmitted && formOfCommunication['communicationTypeId'].errors }"
              >
                <option selected></option>
                @for (object of getDropdownDataObjectArray("communicationTypeId"); track object.id) {
                  <option [ngValue]="object.id">{{object.description}}</option>    
                }
              </select>
              <div class="invalid-feedback">A value is required</div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="mb-3">
            <label for="subject-field" class="form-label">Subject</label>
            <input autocomplete="no-fill" type="text" id="subject-field" class="form-control" placeholder="" formControlName="subject" data-lpignore="true"
              [readonly]="readonly"
              [ngClass]="{ 'is-invalid': formSubmitted && formOfCommunication['subject'].errors }" />
            @if(formOfCommunication['subject'].hasError('maxlength')) {
              <div class="invalid-feedback">Maximum length of {{subjectMaxLength}} characters has been exceeded</div>
            } @else {
              <div class="invalid-feedback">A value is required</div>
            }
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="mb-3">
            <label for="message-field" class="form-label">Message</label>
            <textarea
              class="form-control"
              data-lpignore="true"
              formControlName="message"
              id="message-field"
              [readonly]="readonly"
              [ngClass]="{ 'is-invalid': formSubmitted && formOfCommunication['message'].errors }"
              placeholder=""
              rows="5"
            >
            </textarea>
            <div class="invalid-feedback">A value is required</div>
          </div>
        </div>
      </div>
      
      <div class="row">
        <div class="col-6">
          <div class="mb-3">
            <app-dropdown-date
              [initialDate]="startDate"
              title="Start Date"
              (selectOnChangeEvent)="startDateChanged($event)"
            ></app-dropdown-date>
          </div>
        </div>

        <div class="col-6">
          <div class="mb-3">
            <app-dropdown-date
              [allowUndefinedInitialDate]="true"
              [initialDate]="endDate"
              title="End Date"
              (selectOnChangeEvent)="endDateChanged($event)"
            ></app-dropdown-date>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="form-check form-switch form-switch-md">
            <label class="form-check-label" for="active-field">Active</label>
            <input class="form-check-input" type="checkbox" role="switch" id="active-field" formControlName="active">
          </div>
        </div>
      </div>

      }

    </div>
    <div class="modal-footer">
      <div class="hstack gap-2 justify-content-end">
        <button type="button" class="btn btn-light" data-bs-dismiss="modal" (click)="communicationFormCancel()">Close</button>

        @if (readonly && showReplyIcon && !isLegacySms) {
          <button type="button" class="btn btn-info" (click)="replyMessageClick()">
            <i class="bi bi-reply me-1"></i>Reply
          </button>
        }

        @if (!readonly) {
          <button type="submit" class="btn btn-success" id="add-btn">Submit</button>
        }
      </div>
    </div>
  </form>    
</ng-template>

<app-completed-modal-form #completedModalForm
  (modalClosed)="completedModalHasBeenClosed()"
></app-completed-modal-form>

<app-warning-modal-form #warningModalForm
></app-warning-modal-form>
